import { ItemBaseModel } from '../../../item-base.model';
import { ContentItemBaseModel } from '../content-item-base.model';

export interface ExternalComponentItemModel extends ContentItemBaseModel {
  type: 'external';
  componentId: string;
}

export const isExternalComponentItem = (item: ItemBaseModel): item is ExternalComponentItemModel => {
  return item.type === 'external';
};
